// extracted by mini-css-extract-plugin
export default {"label":"ColorPicker_label__ZNfHm","palette":"ColorPicker_palette__gcHcY","opacity":"ColorPicker_opacity__-QHvk","customColor":"ColorPicker_customColor__hd9lC"};